import {DocumentDataModel} from '../../../../models/document/document-data.model';
import {ITdoImageGridItem} from '../../../../tdo-controls/common/tdo-image-grid/models/i-tdo-image-grid-item';

export class DocumentDataImageModel extends DocumentDataModel implements ITdoImageGridItem {
  description: string;
  imageSource: string;

  // Dont use, just here to make the shared interface happy.
  model: any;
  row: HTMLDivElement;
}
